// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"b3d75a6f","254":"53d76f5a","404":"8714e666"}[chunkId] + ".chunk.js";
};